import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import filterContainer from '@components/ui-components/filter-container/filter-container.vue'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { router } from '@src/routes'
import { mapState } from 'vuex'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      visibleBlock: [],
    }
  },
  components: {
    'filter-container-cmp': filterContainer,
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {},
  beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '')
    this.$root.setDataAnimateFalse('.js-container-decisions ')

    Vue.http.get(`templates${path}`, { params: to.query }).then(
      data => {
        next()
        setTimeout(() => {
          this.template = data.data
          onScrollAnimate()
        }, 500)
      },
      () => {
        next('/404')
      }
    )
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/decisions/index.js